import React from 'react';import { Link } from 'react-router-dom';
import { 
    Box,
    Grid,
    Card, 
    CardContent, 
    Typography,
    Container
} from '@mui/material';
import {
    PersonAdd,
    School,
    ThumbUp,
    Assessment
} from '@mui/icons-material';

import './Dashboard.css';
import { tokens } from '../../theme';
const AuthorDashboard = ({ data }) => {
    const dashboardCards = [
        {
            title: 'Add Content',
            description: 'Upload files or videos for reuse in courses.',
            icon: <PersonAdd sx={{ fontSize: 40, color: '#111110' }} />,
            link: '/contents'
        },
        {
            title: 'Create Courses',
            description: 'Combine content into structured courses.',
            icon: <School sx={{ fontSize: 40, color: '#111110' }} />,
            link: '/courses'
        }
    ];
    return (        
        <Box sx={{ width: '100%', py: '24px' }}>
            <Typography sx={{ fontSize: tokens.font.size.xl, fontWeight: tokens.font.weight.medium, color: tokens.color.textPrimary, marginBottom: '24px', fontFamily: tokens.font.family }}>
                Welcome, {data.user.name}
            </Typography>
            <Grid container spacing={3}>
                {dashboardCards.map((card, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Card 
                            component={Link} 
                            to={card.link}
                            sx={{
                                height: '100%',
                                display: 'block',
                                textDecoration: 'none',
                                transition: 'transform 0.2s, border-color 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    borderColor: '#C8C8C4'
                                }
                            }}
                        >
                            <CardContent sx={{ 
                                display: 'flex', 
                                gap: 2,
                                height: '100%',
                                p: 3
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    bgcolor: '#F0F0EE',
                                    borderRadius: '50%',
                                    p: 2,
                                    height: 80,
                                    width: 80
                                }}>
                                    {card.icon}
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography variant="h6" color="text.primary" gutterBottom>
                                        {card.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {card.description}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default AuthorDashboard;
